import {
  TranslationPermissionMessages,
  PermissionMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationPermissionMessages = {
  [PermissionMessages.linkContractToUserText]: "Vincular contrato al usuario",
  [PermissionMessages.linkContractsSelectedText]:
    "Vincular contratos seleccionados",
  [PermissionMessages.permissionsForText]: "Permisos para",
  [PermissionMessages.searchContractOrConstructionText]: "O busque por el contrato o por la obra"
};
